import { Navigate, Route, useLocation, useParams } from 'react-router-dom';
import { Application } from '@ovh-ux/manager-config';

function Rewrite({ to }: { to: string }): JSX.Element {
  const location = useLocation();
  const params = useParams();
  let target = (to || '').replace(
    /:[^/]+/g,
    (id) => params[id.replace(/:|\?/g, '')],
  );
  target = target.replace(/\*/g, params['*']);
  return <Navigate to={`${target}${location.search}`} replace={true} />;
}

export function Redirections(
  configuration: Record<string, Application>,
): JSX.Element {
  return (
    <>
      <>
        <Route
          path="/useraccount/*"
          element={<Rewrite to="/account/useraccount/*" />}
        />
        <Route
          path="/dedicated/useraccount/*"
          element={<Rewrite to="/account/useraccount/*" />}
        />
        <Route
          path="/dedicated/contacts/*"
          element={<Rewrite to="/account/contacts/*" />}
        />
        <Route
          path="/dedicated/identity-documents/*"
          element={<Rewrite to="/account/identity-documents/*" />}
        />
        <Route
          path="/dedicated/documents/*"
          element={<Rewrite to="/account/documents/*" />}
        />
      </>
      <Route
        path="/dedicated/billing/*"
        element={<Rewrite to="/billing/*" />}
      />
      <Route path="/freefax">
        <Route path=":id/*" element={<Rewrite to="/telecom/freefax/:id/*" />} />
        <Route index element={<Rewrite to="/telecom/freefax/" />} />
      </Route>
      <Route path="/pack">
        <Route path=":id/*" element={<Rewrite to="/telecom/pack/:id/*" />} />
        <Route index element={<Rewrite to="/telecom/pack/" />} />
      </Route>
      <Route path="/sms">
        <Route path=":id/*" element={<Rewrite to="/telecom/sms/:id/*" />} />
        <Route index element={<Rewrite to="/telecom/sms/" />} />
      </Route>
      <Route path="/task" element={<Rewrite to="/telecom/task" />} />
      <Route path="/telephony">
        <Route
          path=":id/*"
          element={<Rewrite to="/telecom/telephony/:id/*" />}
        />
        <Route index element={<Rewrite to="/telecom/telephony/" />} />
      </Route>
      <Route path="/orders" element={<Rewrite to="/telecom/orders" />} />
      <Route
        path="/dedicated/metrics/*"
        element={<Rewrite to="/dedicated/dbaas/logs/*" />}
      />
      <Route path="/overTheBox">
        <Route
          path=":id/*"
          element={<Rewrite to="/telecom/overTheBox/:id/*" />}
        />
        <Route index element={<Rewrite to="/telecom/overTheBox/" />} />
      </Route>
      <Route path="/key-management-service/">
        <Route path="*" element={<Rewrite to="/okms/key-management-service/*" />} />
        <Route index element={<Rewrite to="/okms/key-management-service/" />} />
      </Route>
    </>
  );
}

export default {
  Redirections,
};
